<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 footer-copyright text-center">
      <p class="mb-0">Copyright {{ today | date:'y'}} © jewelstepscrm theme by ThinkerSteps  </p>
    </div>
  </div>
</div>